<template>
  <PForm
    v-model="validado"
    @cancel="limpiar"
    @accept="action"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('action.limpiar')"
  >
    <template>
      <PRow>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.delegaciones"
            :options="delegations"
            optionValue="codDelegacionSol"
            optionText="desDelegacion"
            :label="$t('label.delegaciones')"
            :placeholder="$t('option.select')"
            :readonly="delegations.length === 0"
          />
        </PCol>
        <PCol md="12" v-if="tiposDocumentos.length > 0">
          <PFormSelect
            v-model="valueLocal.documentType"
            :options="aTipoDocumentoOption"
            optionValue="codParametro"
            optionText="desParametro"
            :label="$t('label.tipoDocumento')"
            :placeholder="$t('option.select')"
          ></PFormSelect>
        </PCol>
        <PCol md="12" v-else>
          <PFormInputText
            v-model="valueLocal.documentType"
            :label="$t('label.tipoDocumento')"
          ></PFormInputText>
        </PCol>
        <PCol md="12">
          <PFormInputText
            v-model="valueLocal.documentTitle"
            :label="$t('label.nomFichero')"
          ></PFormInputText>
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaDocumentoInicio"
            :label="$t('label.fechaDocumentoInicio')"
            :endSelector="valueLocal.fechaDocumentoFin"
            :language="locale"
          ></PFormDatepicker>
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaDocumentoFin"
            :label="$t('label.fechaDocumentoFin')"
            :startSelector="valueLocal.fechaDocumentoInicio"
            :maxToday="true"
            :language="locale"
          ></PFormDatepicker>
        </PCol>
      </PRow>
    </template>
  </PForm>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ICliente, IDelegacion, IParametro } from "@/entities";
import { Locale } from "@/store";
import VueMethods from "@/vue-methods";
import { IDocumentacionNonHistoricalFilters } from "@/services";

@Component({
  mixins: [VueMethods],
})
export default class DocumentacionNonHistoricalTableFilters extends Vue {
  @Prop({ required: true })
  tiposDocumentos!: IParametro[];
  @Prop({ required: false })
  textActionName!: string;
  @Prop({ required: false })
  actionName!: string;
  @Prop({ required: false })
  maxRangeMonth?: number;

  @Getter("getLocale") locale!: Locale;
  @Getter("getClienteSelected") clienteSelected!: ICliente;

  @Prop({ required: true }) value!: any;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = JSON.parse(JSON.stringify(this.value)) as IDocumentacionNonHistoricalFilters;

    this.$set(
      this.valueLocal,
      "fechaDocumentoInicio",
      this.getStartDate(this.valueLocal.fechaDocumentoInicio)
    );
    this.$set(
      this.valueLocal,
      "fechaDocumentoFin",
      this.getEndDate(this.valueLocal.fechaDocumentoFin)
    );
  }
  validado = false;
  valueLocal: IDocumentacionNonHistoricalFilters = {
    documentType: "",
    delegaciones: [],
  };
  initialValueLocal: IDocumentacionNonHistoricalFilters = {
    documentType: "",
    delegaciones: [],
  };

  get delegations(): IDelegacion[] {
    let delegationsList: IDelegacion[] = [];
    this.clienteSelected?.clientexdels.forEach((clientexdel) => {
      if (clientexdel.active) delegationsList.push(clientexdel.delegacion);
    });
    return delegationsList.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
  }

  get aTipoDocumentoOption(): IParametro[] {
    const tipos = JSON.parse(JSON.stringify(this.tiposDocumentos)) as IParametro[];
    return tipos
      .map((tipoDocumento) => {
        const label = `documento.tipo.${tipoDocumento.codParametro?.toLowerCase()}`;
        tipoDocumento.desParametro = this.$te(label) ? this.$t(label) : tipoDocumento.desParametro;
        return tipoDocumento;
      })
      .sort((a, b) => this.sortAscending(a, b, "desParametro"));
  }

  limpiar(): void {
    this.$set(this.valueLocal, "fechaDocumentoInicio", undefined);
    this.$set(this.valueLocal, "fechaDocumentoFin", undefined);
    this.valueLocal.documentTitle = undefined;
    this.valueLocal.documentType = "";
    this.valueLocal.delegaciones = [];

    if (!this.isInitialObject(this.value, this.initialValueLocal)) {
      this.$emit("input", this.valueLocal);
      this.$emit("cancel", { action: "clean" });
    }
  }
  action(action: string): void {
    this.$emit("input", this.valueLocal);
    this.$emit("action", { action: action });
  }
}
</script>
